<template>
    <div class="mainBody">
        <div class="searchBox">
            <div class="searchGroup">
                <label>动态类型：</label>
                <el-select v-model="search_Obj.f_moment_type" clearable placeholder="请选择" @keyup.enter.native="doSearch">
                    <el-option v-for="item in enuObj('moment_type')" :key="'moment_type'+item.key" :label="item.title" :value="item.key"> </el-option>
                </el-select>
            </div>
            <div class="searchGroup">
                <label>邮箱：</label>
                <el-input v-model="search_Obj.f_mail" clearable @keyup.enter.native="doSearch"></el-input>
            </div>
            <div class="searchGroup">
                <label>昵称：</label>
                <el-input v-model="search_Obj.f_nickname" clearable @keyup.enter.native="doSearch"></el-input>
            </div>
            <div class="searchGroup">
                <label>所在分类：</label>
                <el-select v-model="search_Obj.f_cate_id" clearable placeholder="请选择" @keyup.enter.native="doSearch">
                    <el-option v-for="item in cateList" :key="'cl'+item.id" :label="item.cate_name" :value="item.id"> </el-option>
                </el-select>
            </div>
            <div class="searchGroup">
                <label>所属话题：</label>
                <el-select v-model="search_Obj.f_topic_id" clearable placeholder="请选择" @keyup.enter.native="doSearch">
                    <el-option v-for="item in topicList" :key="'tp'+item.id" :label="item.topic_name" :value="item.id"> </el-option>
                </el-select>
            </div>
            <div class="searchGroup">
                <label>审核状态：</label>
                <el-select v-model="search_Obj.f_sh_state" clearable placeholder="请选择" @keyup.enter.native="doSearch">
                    <el-option v-for="item in enuObj('shstate')" :key="'shstate'+item.key" :label="item.title" :value="item.key"> </el-option>
                </el-select>
            </div>
            <div class="searchGroup">
                <label>发布时间：</label>
                <el-date-picker v-model="dateRange" type="daterange" value-format="yyyy-MM-dd" unlink-panels
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :picker-options="pickerOptions"
                    @change="dateRangeSet"
                    style="width:320px">
                </el-date-picker>
            </div>
            <el-button type="primary" plain @click.native="doSearch">搜索</el-button>
            <Btns :menu_id="menu_id" :menus="main_btns" @on_btnclk="btnClick"></Btns>
        </div>
        <div class="dataBox">
            <el-table :data="tableData" :default-sort="sortData" @sort-change="sortChange" @selection-change="selectChanges" v-loading="loading" border stripe>
                <el-table-column type="selection" align="center" width="50"></el-table-column>
                <el-table-column prop="id" label="ID" sortable="custom" width="100px"></el-table-column>
                <el-table-column prop="moment_type" label="动态类型" sortable="custom" width="120">
                    <template slot-scope="scope">
                        <span>{{ transEnu(scope.row.moment_type, "moment_type") }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="mail" label="邮箱" sortable="custom" width="160"></el-table-column>
                <el-table-column prop="nickname" label="昵称" sortable="custom" width="160"></el-table-column>
                <el-table-column prop="cate_name" label="所在分类" sortable="custom"></el-table-column>
                <el-table-column prop="topic_name" label="所在话题" sortable="custom"></el-table-column>
                <el-table-column prop="title" label="标题" sortable="custom"></el-table-column>
                <el-table-column prop="content" label="内容" sortable="custom"></el-table-column>
                <el-table-column prop="view_count1" label="曝光量" sortable="custom" width="100"></el-table-column>
                <el-table-column prop="view_count" label="浏览量" sortable="custom" width="100"></el-table-column>
                <el-table-column prop="like_count" label="点赞量" sortable="custom" width="100"></el-table-column>
                <el-table-column prop="comment_count" label="评论量" sortable="custom" width="100"></el-table-column>
                <el-table-column prop="share_count" label="分享量" sortable="custom" width="100"></el-table-column>
                <el-table-column prop="add_time" label="发布时间" sortable="custom"></el-table-column>
                <el-table-column prop="sh_state" label="审核状态" sortable="custom" width="110" fixed="right">
                    <template slot-scope="scope">
                        <span>{{ transEnu(scope.row.sh_state, "shstate") }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="140" align="center" fixed="right">
                    <template slot-scope="scope">
                        <LabBtns :menu_id="menu_id" :row="scope.row" :index="scope.$index" :menus="lab_btns" @on_btnclk="labelClick"></LabBtns>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pageBox" style="justify-content: space-between">
            <div style="font-size: 13px;">
                <span style="margin-right: 40px;">曝光量：{{view_count1}}</span>
                <span style="margin-right: 40px;">浏览量：{{view_count}}</span>
                <span style="margin-right: 40px;">点赞量：{{like_count}}</span>
                <span style="margin-right: 40px">评论量：{{comment_count}}</span>
                <span style="margin-right: 40px">分享量：{{share_count}}</span>
            </div>
            <el-pagination background layout="total, prev, pager, next, jumper" :current-page="current" :total="total" @current-change="pageChange"></el-pagination>
        </div>
        <Edit
            width="750px"
            :id="model_id"
            :title="edit_title"
            :isshow="editshow"
            :cateList="cateList"
            :topicList="topicList"
            @on-close="closeEditDialog"
            @on-save-ok="saveOk">
        </Edit>
        <Info
            width="750px"
            :id="model_id"
            title="查看动态"
            :isshow="infoshow"
            @on-close="closeInfoDialog">
        </Info>
        <SelTopic
            width="500px"
            title="批量设置话题"
            :isshow="seltopic_show"
            :topicList="topicList"
            @on-close="closeSelTopicDialog"
            @on-save-ok="selTopicOk">
        </SelTopic>
        <SelCate
            width="500px"
            title="批量设置分类"
            :isshow="selcate_show"
            :cateList="cateList"
            @on-close="closeSelCateDialog"
            @on-save-ok="selCateOk">
        </SelCate>
    </div>
</template>

<script>
import Btns from "@/components/common/btns"
import LabBtns from "@/components/common/labbtns"
import Edit from "./edit"
import Info from "./info"
import SelTopic from "./seltopic"
import SelCate from "./selcate"
import listutil from "@/libs/listutil"
import { getListData } from '@/api/common'
import { updateTopic, updateCate, exportMoment } from '@/api/moment'

export default {
    name: 'momentList',
    mixins: [listutil],
    components: { Edit, Info, Btns, LabBtns, SelTopic, SelCate },
    data() {
        return {
            m_name: '动态',
            menu_id: 8100,
            pagesize: 50,
            list_url: "/api/admin/moment/list",
            search_Obj: {
                f_nickname: '',
                f_mail: '',
                f_moment_type: '',
                f_sh_state: '',
                f_cate_id: '',
                f_topic_id: '',
                f_add_time_s_date: '',
                f_add_time_e_date: ''
            },
            del_Obj:{
                url:'/api/admin/moment/del',
                data:{
                    ids:''
                }
            },
            enu_name: ['shstate', 'moment_type'],
            cateList: [],
            topicList: [],
            dateRange: '',
            view_count: 0,
            comment_count: 0,
            view_count1: 0,
            like_count: 0,
            share_count: 0,
            seltopic_show: false,
            selcate_show: false,
        };
    },
    methods: {
        dateRangeSet(val){
            if(this.$isNotNull(val)){
                this.search_Obj.f_add_time_s_date = val[0]
                this.search_Obj.f_add_time_e_date = val[1]
            }else{
                this.search_Obj.f_add_time_s_date = ''
                this.search_Obj.f_add_time_e_date = ''
            }
        },
        getListData() {
            this.loading = true;
            this.selectData = [];
            getListData(this.list_url, this.search_Obj).then(res => {
                this.loading = false;
                if (res.code === 1) {
                    this.tableData = res.data.pageInfo.resultList;
                    this.total = res.data.pageInfo.totalRecords;
                    if(res.data.pageInfo.pageNum ==1){
                        this.cateList = res.data.cateList;
                        this.topicList = res.data.topicList
                        this.view_count = res.data.view_count
                        this.comment_count = res.data.comment_count
                        this.view_count1 = res.data.view_count1
                        this.like_count = res.data.like_count
                        this.share_count = res.data.share_count
                    }
                }
            })
        },
        batchCate(){
            if (this.selectData.length <= 0) {
                this.$msg("请先选择要分配的数据")
            } else {
                this.selcate_show = true
            }
        },
        selCateOk(e){
            let ids = '';
            for (let data of this.selectData) {
                if (ids === '') {
                    ids = data.id + "";
                } else {
                    ids += "," + data.id;
                }
            }
            updateCate(e.cate_id, ids).then(res =>{
                this.selcate_show = false
                this.getListData()
                if(res.code ==1){
                    this.$msgs("设置成功")
                }else{
                    this.$msg(res.msg)
                }
            })
        },
        closeSelCateDialog(){
            this.selcate_show = false
        },
        batchTopic(){
            if (this.selectData.length <= 0) {
                this.$msg("请先选择要分配的数据")
            } else {
                this.seltopic_show = true
            }
        },
        selTopicOk(e){
            let ids = '';
            for (let data of this.selectData) {
                if (ids === '') {
                    ids = data.id + "";
                } else {
                    ids += "," + data.id;
                }
            }
            updateTopic(e.topic_id, ids).then(res =>{
                this.seltopic_show = false
                this.getListData()
                if(res.code ==1){
                    this.$msgs("设置成功")
                }else{
                    this.$msg(res.msg)
                }
            })
        },
        closeSelTopicDialog(){
            this.seltopic_show = false
        },
        export(){
            exportMoment(this.search_Obj.f_nickname, this.search_Obj.f_mail, this.search_Obj.f_moment_type, this.search_Obj.f_cate_id, this.search_Obj.f_topic_id, this.search_Obj.f_sh_state, this.search_Obj.f_add_time_s_date, this.search_Obj.f_add_time_e_date).then(res=>{
                if(res.code ==1){
                    setTimeout(() => {
                        window.open(res.data+"")
                    }, 500);
                }else {
                    this.$msg(res.msg)
                }
            })
        },
    }
};
</script>